import { mapGameTime } from "../../composables/mappers";
export const updateGameTime = (event, gameTime) => {
    if (event && event.liveGameState && event.liveGameState.gameTime) {
        event.liveGameState.gameTime = gameTime;
        mapGameTime(event);
    }
    return event;
};
//# sourceMappingURL=updateGameTime.js.map